import type { SxProps, Theme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import type React from 'react';
import { NAVY, RADIUS_COIN, SHADOW, SURFACE_CONTAINER_LOW, SURFACE_CONTAINER_LOWEST } from 'styles/tokens';

interface SegmentedTabsProps {
  tabs: string[];
  value: number;
  onChange: (newValue: number) => void;
  sx?: SxProps<Theme>;
}

const defaultSx = {
  minHeight: 44,
  width: 'fit-content',
  bgcolor: SURFACE_CONTAINER_LOW,
  borderRadius: RADIUS_COIN,
  p: 0.5,
  '& .MuiTabs-indicator': { display: 'none' },
  '& .MuiTab-root': {
    minHeight: 36,
    borderRadius: RADIUS_COIN,
    textTransform: 'none',
    fontWeight: 600,
    fontFamily: 'Jost, sans-serif',
    color: NAVY,
    opacity: 0.5,
    px: 3,
    transition: 'all 0.2s ease',
    '&.Mui-selected': {
      opacity: 1,
      bgcolor: SURFACE_CONTAINER_LOWEST,
      boxShadow: SHADOW,
      color: NAVY,
    },
  },
} as const;

const SegmentedTabs: React.FC<SegmentedTabsProps> = ({ tabs, value, onChange, sx }) => (
  <Tabs value={value} onChange={(_e, newValue: number) => onChange(newValue)} sx={{ ...defaultSx, ...sx }}>
    {tabs.map((label) => (
      <Tab key={label} label={label} />
    ))}
  </Tabs>
);

export default SegmentedTabs;
